export const UnitMensure = {
  W: "ton/h",
  WVol: "m³/h",
  T: "°C",
  POL: "%",
  ARTPorcentagem: "%",
  ART: "ton/h",
  pot: "MW",
  AR: "%",
  P: "Bar",
  brix: "%",
  pureza: "%",
  impureza: "%",
  fracaoMassica: "%",
}